// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1Am_F","itemTitle":"ClientEmergencyInfo_itemTitle__2Hl98","itemText":"ClientEmergencyInfo_itemText__6doRw"};